import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "slider", "switchText"];

    static values = {
        isDisabled: Boolean,
        alwaysEnabledText: String,
        alwaysDisabledText: String,
        disabledText: String,
        enabledText: String
    };

    connect() {
        this.updateState();
        this.updateDisabledClass();
    }

    toggle(event) {
        if (this.isDisabledValue) {
            event.preventDefault();
            return;
        }

        this.updateState();
        this.dispatchChangeEvent();
    }

    updateState() {
        const isChecked = this.inputTarget.checked;

        if (this.isDisabledValue) {
            this.switchTextTarget.innerHTML = isChecked
                ? this.alwaysEnabledTextValue
                : this.alwaysDisabledTextValue;
        } else {
            if (this.enabledTextValue !== "" || this.disabledTextValue !== "") {
                this.switchTextTarget.innerHTML = isChecked
                    ? this.enabledTextValue
                    : this.disabledTextValue;
            }
        }

        this.element.dataset.checked = isChecked;
        this.element.dataset.state = isChecked ? 'on' : 'off';

        this.inputTarget.setAttribute('aria-checked', isChecked);
    }

    updateDisabledClass() {
        if (this.isDisabledValue) {
            this.element.classList.add('is-disabled');
        } else {
            this.element.classList.remove('is-disabled');
        }
    }

    setChecked(value) {
        if (this.isDisabledValue) return;

        this.inputTarget.checked = value;
        this.updateState();
        this.dispatchChangeEvent();
    }

    dispatchChangeEvent() {
        const event = new CustomEvent('switch:change', {
            detail: {
                checked: this.inputTarget.checked,
                name: this.inputTarget.name,
                value: this.inputTarget.value
            },
            bubbles: true
        });

        this.element.dispatchEvent(event);
    }
}
